import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { showToast } from "../../utils/toast";

const UserDetailInfo = () => {
  const { id } = useParams();
  const location = useLocation();
  const { t } = useLanguage();
  const user = location.state?.user || null;

  useEffect(() => {
    if (!user) {
      showToast("error", t("userDetail.userNotFound", "User not found!"));
    }
  }, [user, t]);

  if (!user) return (
    <div className="container py-5">
      <div className="alert alert-danger">
        {t("userDetail.userNotFound", "User not found!")}
      </div>
    </div>
  );

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-lg-12">
          {/* Header with back button */}
          <div className="d-flex align-items-center mb-4">
            <button 
              className="btn btn-outline-secondary btn-sm rounded-circle me-3"
              onClick={() => window.history.back()}
            >
              <i className="bi bi-arrow-left"></i>
            </button>
            <h2 className="mb-0 text-dark fw-semibold">
              {t("userDetail.heading", "User Profile")}
            </h2>
          </div>

          {/* Main Card */}
          <div className="card border-0 shadow-sm rounded-lg">
            {/* Profile Header */}
            <div className="bg-light p-4 border-bottom">
              <div className="d-flex align-items-center">
                <div className="avatar-lg me-4">
                  <div className="avatar-img rounded-circle bg-white d-flex align-items-center justify-content-center border" style={{width: '80px', height: '80px'}}>
                    <i className="bi bi-person fs-3 text-muted"></i>
                  </div>
                </div>
                <div>
                  <h3 className="mb-1 fw-semibold">{user.name}</h3>
                  {user.c_name && (
                    <p className="text-muted mb-0">
                      <i className="bi bi-building me-1"></i>
                      {user.c_name}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Card Body */}
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="fw-semibold text-muted mb-3">
                    <i className="bi bi-person-lines-fill me-2"></i>
                    Contact Information
                  </h5>
                  
                  <div className="mb-4">
                    <div className="d-flex align-items-start mb-3">
                      <i className="bi bi-envelope text-muted me-3 mt-1"></i>
                      <div>
                        <p className="text-muted small mb-1">Email</p>
                        <p className="mb-0 fw-medium text-break">{user.email}</p>
                      </div>
                    </div>

                    {user.phone_number && (
                      <div className="d-flex align-items-start">
                        <i className="bi bi-telephone text-muted me-3 mt-1"></i>
                        <div>
                          <p className="text-muted small mb-1">Phone</p>
                          <p className="mb-0 fw-medium">{user.phone_number}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  {user.c_name && (
                    <>
                      <h5 className="fw-semibold text-muted mb-3">
                        <i className="bi bi-building me-2"></i>
                        Company Information
                      </h5>
                      <div className="d-flex align-items-start">
                        <i className="bi bi-building text-muted me-3 mt-1"></i>
                        <div>
                          <p className="text-muted small mb-1">Company Name</p>
                          <p className="mb-0 fw-medium">{user.c_name}</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Card Footer */}
            <div className="card-footer bg-white border-top py-3">
              <small className="text-muted">
                User ID: {id}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailInfo;